
    <ng-container *ngIf="alignment === 'left'; else centerOrRight">
      <ng-container *ngTemplateOutlet="contentElem"></ng-container>
    </ng-container>
    <ng-template #centerOrRight>
      <div class="d-flex justify-content-{{ alignment }}">
        <ng-container *ngTemplateOutlet="contentElem"></ng-container>
      </div>
    </ng-template>
    <ng-template #contentElem>
      <ng-container *ngIf="content$ | async as content">
        <span
          *ngIf="content | filled"
          [matTooltip]="tooltip"
          [class.fieldmagic-text-title]="purpose == 'title'"
          [class.fieldmagic-text-link]="purpose == 'link'"
          [class.fieldmagic-text-input-label]="purpose == 'input'"
          [class.fieldmagic-text-with-required-mark]="withRequiredMarker"
          [class.fieldmagic-text-error]="purpose == 'error'"
          [class.fieldmagic-text-body]="purpose == 'body'"
          [class.fieldmagic-text-help]="purpose == 'help'"
          [class.fieldmagic-text-secondary-display]="purpose == 'secondary-display'"
        >
          {{ content | translate }}
        </span>
      </ng-container>
    </ng-template>
  